import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

export const INVALID_DATE = '0000-00-00 00:00:00';

export const isValidDate = (date?: string | null) => date && date !== INVALID_DATE;

export function transformDateString(str: string | null | undefined, format?: string): string | null {
  if (!isValidDate(str)) {
    return null;
  }
  const date = dayjs(str);
  return date.isValid() ? dayjs(date).format(format || 'DD/MM/YYYY HH:mm:ss') : null;
}

export function transformDateFrance(date: string | null | undefined): dayjs.Dayjs | null {
  if (!isValidDate(date)) {
    return null;
  }
  dayjs.extend(utc);
  dayjs.extend(timezone);
  return dayjs(date).tz('Europe/Paris');
}

export function transformDateStringFrance(date: string | null | undefined, format?: string): string | null {
  const frDate = transformDateFrance(date);

  if (!frDate) {
    return null;
  }

  return frDate.format(format || 'DD/MM/YYYY HH:mm:ss');
}

export function dayJsFromString(str: string, format?: string): dayjs.Dayjs | null {
  const date = dayjs(str, format);
  return date.isValid() ? date : null;
}
